/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'input[appInputMaxLength]'
})
export class MaxLengthDirective {
    @Input() appInputMaxLength: number;

    constructor(private _el: ElementRef) {
    }

    @HostListener('input', ['$event']) onInputChange(event: any): void {
        const length = event.target.value.length;
        if (length >= this.appInputMaxLength) {
            this._el.nativeElement.value = event.target.value.substring(0, this.appInputMaxLength);
            event.stopPropagation();
        }
    }
}
